import React, { useContext } from 'react'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import Popup from '@Components/Popups/Popup'
import Button from '@Components/Buttons/Button'
import { ICONS } from '@Const/common'
import { observer } from 'mobx-react'
import FileReviewPopupErrors from '@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewStepPopup/FileReviewPopupErrors'
import FileReviewPopupSuccess from '@Scenes/WorkScenes/Steps/FileReviewStep/FileReviewStepPopup/FileReviewPopupSuccess'

interface FileReviewStepPopupProps {
    numComplete: number
    numErrors: number
}

const FileReviewStepPopup = (props: FileReviewStepPopupProps) => {
    const { uiStore } = useContext<RootStore>(StoresContext)
    const { numComplete, numErrors } = props

    return (
        <Popup showClose={false} onClose={() => uiStore.setBulkUploadModalIsOpen(false)}>
            <div className="status-overview">
                {numErrors ? (
                    <FileReviewPopupErrors numComplete={numComplete} numErrors={numErrors} />
                ) : (
                    <FileReviewPopupSuccess numComplete={numComplete} />
                )}
                <div className="search-confirm-popup-content">
                    <div className="buttons-block">
                        <Button
                            mainColor
                            type="primary"
                            icon={ICONS.arrow_forward}
                            onClick={() => uiStore.setBulkUploadModalIsOpen(false)}
                        >
                            Continue
                        </Button>
                    </div>
                </div>
            </div>
        </Popup>
    )
}

export default observer(FileReviewStepPopup)
